import { supabase } from '@/integrations/supabase/client';

export type LikeMetrics = {
  contentId: string;
  count: number;
  userHasLiked: boolean;
};

const likesMetricsService = {
  async getCount(contentId: string, contentType: string): Promise<number> {
    try {
      // Use the correct table name based on content type
      const tableName = contentType === 'poll' ? 'poll_likes' : 'card_likes';
      
      // Use proper field name based on content type
      const idField = contentType === 'poll' ? 'poll_id' : 'card_id';
      
      const { count, error } = await supabase
        .from<any, any>(tableName)
        .select('*', { count: 'exact', head: true })
        .eq(idField, contentId);
      
      if (error) throw error;
      return count || 0;
    } catch (error) {
      console.error('Error getting likes count:', error);
      return 0;
    }
  },
  
  async checkUserLike(contentId: string, contentType: string, userId: string): Promise<boolean> {
    if (!userId) return false;
    
    try {
      // Use the correct table name based on content type
      const tableName = contentType === 'poll' ? 'poll_likes' : 'card_likes';
      
      // Use proper field name based on content type
      const idField = contentType === 'poll' ? 'poll_id' : 'card_id';
      
      const { data, error } = await supabase
        .from<any, any>(tableName)
        .select('id')
        .eq(idField, contentId)
        .eq('user_id', userId)
        .limit(1);

      if (error) throw error;
      return data && data.length > 0;
    } catch (error) {
      console.error('Error checking if user liked content:', error);
      return false;
    }
  }
};

export default likesMetricsService;
